import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'environments/environment';
@Component({
    selector: 'app-jc3-block-6',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './jc3-block-6.component.html',
    styleUrl: './jc3-block-6.component.scss',
})
export class Jc3Block6Component {
    bnmUobLogo: { title: string; image: string; link: string }[] = [
        {
            title: 'BNM',
            image: `${environment.imageBaseUrl}BNM.svg`,
            link: 'https://www.bnm.gov.my/',
        },
        {
            title: 'UOB',
            image: `${environment.imageBaseUrl}UOB.svg`,
            link: 'https://www.uob.com.my/',
        },
    ];

    banksLogo: { title: string; image: string; link: string }[] = [
        {
            title: 'Suruhanjaya Sekuriti Malaysia',
            image: `${environment.imageBaseUrl}SECCOM.svg`,
            link: 'https://www.sc.com.my/',
        },
        {
            title: 'Allianz',
            image: `${environment.imageBaseUrl}ALLIANZ.svg`,
            link: 'https://www.allianz.com.my/personal.html',
        },
        {
            title: 'Alliance',
            image: `${environment.imageBaseUrl}ALLIANCE.svg`,
            link: 'https://www.alliancebank.com.my/',
        },
        {
            title: 'AMB',
            image: `${environment.imageBaseUrl}AMBANK.svg`,
            link: 'https://www.ambank.com.my/',
        },
        {
            title: 'Bank Islam',
            image: `${environment.imageBaseUrl}BANKISLAM.svg`,
            link: 'https://www.bankislam.com/',
        },
        {
            title: 'CIMB',
            image: `${environment.imageBaseUrl}CIMB.svg`,
            link: 'https://www.cimb.com.my/en/personal/home.html',
        },
        {
            title: 'Generali',
            image: `${environment.imageBaseUrl}GENERALI.svg`,
            link: 'https://www.generali.com.my/',
        },
        {
            title: 'Hong Leong',
            image: `${environment.imageBaseUrl}HLB.svg`,
            link: 'https://www.hlb.com.my/en/personal-banking/home.html',
        },
        {
            title: 'MBSB',
            image: `${environment.imageBaseUrl}MBSB.svg`,
            link: 'https://www.mbsb.com/mbsbbank/',
        },
        {
            title: 'Public Bank',
            image: `${environment.imageBaseUrl}PUBLICBANK.svg`,
            link: 'https://www.pbebank.com/',
        },
        {
            title: 'RHB',
            image: `${environment.imageBaseUrl}RHB.svg`,
            link: 'https://www.rhbgroup.com/index.html',
        },
        {
            title: 'SME Bank',
            image: `${environment.imageBaseUrl}SMEBANKBPMB.svg`,
            link: 'https://www.smebank.com.my/',
        },
    ];

    insuranceLogo: { title: string; image: string; link: string }[] = [
        {
            title: 'Tokio Marine',
            image: `${environment.imageBaseUrl}TOKIOMARINE.svg`,
            link: 'https://www.tokiomarine.com/my/en.html',
        },
        {
            title: 'Zurich',
            image: `${environment.imageBaseUrl}ZURICH.svg`,
            link: 'https://www.zurich.com.my/',
        },
    ];

    othersLogo: { title: string; image: string; link: string }[] = [
        {
            title: 'SMECorp',
            image: `${environment.imageBaseUrl}SMECORP.svg`,
            link: 'https://smecorp.gov.my/index.php/en/',
        },
        {
            title: 'CGC',
            image: `${environment.imageBaseUrl}CGC.svg`,
            link: 'https://www.cgc.com.my/en-us/',
        },
        {
            title: 'CMM',
            image: `${environment.imageBaseUrl}CMM.svg`,
            link: 'https://www.capitalmarketsmalaysia.com/',
        },
        {
            title: 'MTA',
            image: `${environment.imageBaseUrl}MTA.svg`,
            link: 'https://enroll.malaysiantakaful.com.my/',
        },
        {
            title: 'UNGCMYB',
            image: `${environment.imageBaseUrl}UNGCMYB.svg`,
            link: 'https://www.ungcmbc.org/',
        },
        {
            title: 'PWC',
            image: `${environment.imageBaseUrl}PWC.svg`,
            link: 'https://www.pwc.com/my/en.html',
        },
    ];

    desktopLogos = [
        ...this.banksLogo,
        ...this.insuranceLogo,
        ...this.othersLogo,
    ];

    makeSlug(str: string) {
        return str?.toLowerCase()?.replaceAll(' ', '_');
    }
}
